"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1019],{

/***/ 97105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NK": function() { return /* binding */ family; },
/* harmony export */   "O7": function() { return /* binding */ product; },
/* harmony export */   "nw": function() { return /* binding */ domain; }
/* harmony export */ });
var domain = {
    field_form_field_title: "Domain",
    field_label: "Domain",
    field_input_type: "Dropdown",
    field_related_dropdown: "Family",
    field_options: [
        "Consumer",
        "Customer Development",
        "Customer Operations",
        "Cyber Foundation",
        "Data Foundation",
        "DBO (People)",
        "DBO (Procurement)",
        "DBO (R&D)",
        "DBO (Supply Chain)",
        "Finance",
        "Tech Foundation", 
    ],
    field_input: "Select Domain",
    field_message_ip_error_message: "Domain is mandatory",
    field_required: "1",
    field_dropdown_option_component: [
        {
            field_title: "",
            field_options: []
        }, 
    ],
    field_editable: "",
    field_column_size: "",
    value: "domain"
};
var family = {
    field_form_field_title: "Family",
    field_label: "Family",
    field_input_type: "Related Dropdown",
    field_related_dropdown: "Product",
    field_options: [],
    field_input: "Select Family",
    field_message_ip_error_message: "Family is mandatory",
    field_required: "1",
    field_dropdown_option_component: [
        {
            field_title: "Consumer",
            field_options: [
                "Consumer Services",
                "Creative & Media",
                "Engage",
                "Insights",
                "Product Innovation & Pack Design", 
            ]
        },
        {
            field_title: "Customer Development",
            field_options: [
                "Category Management",
                "Customer Business Planning, JBP, Collaboration",
                "dCom Execution",
                "DT Execution",
                "Enterprise & Professional Sales",
                "MT Execution", 
            ]
        },
        {
            field_title: "Customer Operations",
            field_options: [
                "Integrated Planning & Customer Connectivity",
                "Logistics",
                "Master Data Governance",
                "Order to Cash", 
            ]
        },
        {
            field_title: "DBO (People)",
            field_options: [
                "Data Management & Insights",
                "Employee Performance",
                "Global Mobility",
                "JML",
                "Payroll",
                "Talent Acquisition ", 
            ]
        },
        {
            field_title: "DBO (Procurement)",
            field_options: [
                "Forecasting",
                "Procurement Operations",
                "Risk Management",
                "Sourcing",
                "Supplier Management",
                "Sustainability & Environment",
                "Travel & Expense", 
            ]
        },
        {
            field_title: "DBO (R&D)",
            field_options: [
                "Capture (Real World Experiment)",
                "Create (Product Development)",
                "Exploit (Data & Model Management)",
                "Portfolio Management",
                "Simulate (Virtual World Experiment)", 
            ]
        },
        {
            field_title: "DBO (Supply Chain)",
            field_options: [
                "Make (In-House & 3P)",
                "Quality Management",
                "Safety",
                "Security", 
            ]
        },
        {
            field_title: "Finance",
            field_options: [
                "Compliance & Audit",
                "External Reporting & Consolidation",
                "Finance Operations",
                "Legal",
                "Planning & Performance Management",
                "Tax & Treasury ", 
            ]
        },
        {
            field_title: "Tech Foundation",
            field_options: [
                "Corporate Communication",
                "Employee & Collaboration Tech Experience",
                "Enterprise Platforms",
                "Facility Services",
                "Master Data Tech",
                "Risk & Compliance",
                "Technology Infrastructure",
                "Travel Services", 
            ]
        },
        {
            field_title: "Cyber Foundation",
            field_options: [
                "Detect",
                "Govern",
                "Identify",
                "Protect",
                "Recover",
                "Respond", 
            ]
        },
        {
            field_title: "Data Foundation",
            field_options: [
                "Analytical Solutions & Design (xOps)",
                "Data Enablement",
                "Data Science & AI", 
            ]
        }, 
    ],
    field_editable: "",
    field_column_size: ""
};
var product = {
    field_form_field_title: "Product",
    field_label: "Product",
    field_input_type: "Related Dropdown",
    field_related_dropdown: "",
    field_options: [],
    field_input: "Select Product",
    field_message_ip_error_message: "Product is mandatory",
    field_required: "1",
    field_dropdown_option_component: [
        {
            field_title: "Consumer Services",
            field_options: [
                "Ad Production Management",
                "Agency Operations & Management",
                "Consumer Data Management",
                "Digital Asset Management (Consumer)",
                "Experience Compliance", 
            ]
        },
        {
            field_title: "Creative & Media",
            field_options: [
                "Creative Production",
                "Media Management & Optimisation",
                "Retail Media Management", 
            ]
        },
        {
            field_title: "Engage",
            field_options: [
                "Advanced & Immersive Experiences",
                "Carelines (CEC)",
                "Community Management",
                "Direct Messaging (Email & SMS)",
                "Loyalty & Rewards",
                "Web Experience Management & Optimisation", 
            ]
        },
        {
            field_title: "Insights",
            field_options: [
                "Briefing",
                "Signals"
            ]
        },
        {
            field_title: "Product Innovation & Pack Design",
            field_options: [
                "Artwork Management",
                "Innovation Management",
                "Pack Design", 
            ]
        },
        {
            field_title: "Category Management",
            field_options: [
                "Assortment & Shelf Optimisation",
                "Integrated NRM & Pricing",
                "Performance Management & Category Insights", 
            ]
        },
        {
            field_title: "Customer Business Planning, JBP, Collaboration",
            field_options: [
                "Joint Business Planning & Collaboration",
                "Promotion Analytics & Optimisation",
                "Promotion Planning & Management", 
            ]
        },
        {
            field_title: "dCom Execution",
            field_options: [
                "Content",
                "Performance & Execution",
                "Retail Media"
            ]
        },
        {
            field_title: "DT Execution",
            field_options: [
                "DT Operations",
                "DT Route-to-Market & Marketplace",
                "Intelligent Cabinets & Operations", 
            ]
        },
        {
            field_title: "Enterprise & Professional Sales",
            field_options: [
                "Digital Selling (OOH)",
                "Digital Selling (ULI, UFS)"
            ]
        },
        {
            field_title: "MT Execution",
            field_options: [
                "CRM & Field Force Management",
                "Intelligent In-store Execution",
                "Retail POSM Management", 
            ]
        },
        {
            field_title: "Integrated Planning & Customer Connectivity",
            field_options: [
                "Autonomous Planning & Customer Connectivity",
                "Integrated Forecast",
                "Integrated Supply Planning",
                "Plan Analytics", 
            ]
        },
        {
            field_title: "Logistics",
            field_options: [
                "D2C Logistics",
                "Logistics Analytics",
                "Transportation Management",
                "Warehouse Management", 
            ]
        },
        {
            field_title: "Master Data Governance",
            field_options: [
                "Customer Master",
                "Data Quality Governance",
                "Price Master",
                "Product Master", 
            ]
        },
        {
            field_title: "Order to Cash",
            field_options: [
                "Cash & Collections Management",
                "Claims Management",
                "Credit Management",
                "Order to Invoice Management",
                "Sales Order Fulfilment", 
            ]
        },
        {
            field_title: "Detect",
            field_options: [
                "Adverse Event Analysis",
                "Continuous Monitoring"
            ]
        },
        {
            field_title: "Govern",
            field_options: [
                "Controls Assurance Posture",
                "Cyber Security Risk Management",
                "Policies, Standards & Governance",
                "Third Party Cyber Security Risk Management", 
            ]
        },
        {
            field_title: "Identify",
            field_options: [
                "Asset Identification",
                "Asset Risk Assessment & Management",
                "Attack Surface Management",
                "Threat Intelligence", 
            ]
        },
        {
            field_title: "Protect",
            field_options: [
                "Human Risk",
                "Insider Risk",
                "Offensive Security",
                "Platform Security",
                "Threat Vulnerability Management", 
            ]
        },
        {
            field_title: "Recover",
            field_options: [
                "Incident Recovery Plan & Execution"
            ]
        },
        {
            field_title: "Respond",
            field_options: [
                "Case Management & Triage",
                "Cyber Security Incident Management & Mitigation",
                "Forensics & Post-Incident Analysis", 
            ]
        },
        {
            field_title: "Analytical Solutions & Design (xOps)",
            field_options: [
                "Automation (Data Foundation)",
                "Reporting (Data Foundation)",
                "Service Management, DataOps, DevOps, ML Ops",
                "Solution & Product Delivery",
                "Vendor Management & Outsourced Services", 
            ]
        },
        {
            field_title: "Data Enablement",
            field_options: [
                "Data & Insights Democratisation",
                "Data Architecture & Engineering",
                "Data Governance (Data Foundation)",
                "Data Platform",
                "Data Strategy", 
            ]
        },
        {
            field_title: "Data Science & AI",
            field_options: [
                "AI Assurance & Ethics",
                "AI Foundation",
                "AI Labs & Innovation",
                "AI Literacy",
                "AI Strategy",
                "Enterprise Data Science & AI Models", 
            ]
        },
        {
            field_title: "Data Management & Insights",
            field_options: [
                "Employee Listening",
                "People Master Data",
                "Reporting (People)",
                "Workforce Planning", 
            ]
        },
        {
            field_title: "Employee Performance",
            field_options: [
                "Health & Wellbeing",
                "Learning & Development",
                "Performance Management", 
            ]
        },
        {
            field_title: "Global Mobility",
            field_options: [
                "International Assignment",
                "Short Term Assignment"
            ]
        },
        {
            field_title: "JML",
            field_options: [
                "Joiners, Movers, Leavers"
            ]
        },
        {
            field_title: "Payroll",
            field_options: [
                "Benefits & Reward",
                "Employee Pay",
                "Time & Attendance"
            ]
        },
        {
            field_title: "Talent Acquisition",
            field_options: [
                "Contingent Workforce Recruitment",
                "Employee Recruitment", 
            ]
        },
        {
            field_title: "Forecasting",
            field_options: [
                "Material Price Forecasting"
            ]
        },
        {
            field_title: "Procurement Operations",
            field_options: [
                "Contracting",
                "Onboarding & Supplier Master Data",
                "Payments",
                "Supplier Collaboration",
                "Supplier Helpdesk",
                "Tea Operations", 
            ]
        },
        {
            field_title: "Risk Management",
            field_options: [
                "Commodity Risk Management"
            ]
        },
        {
            field_title: "Sourcing",
            field_options: [
                "E-Tendering",
                "Non-Strategic Sourcing",
                "Spend Analytics",
                "Supplier Scouting", 
            ]
        },
        {
            field_title: "Supplier Management",
            field_options: [
                "Compliance & Reporting",
                "Supplier Quality Assurance",
                "Supplier Relationship Management",
                "Supplier Risk Management", 
            ]
        },
        {
            field_title: "Sustainability & Environment",
            field_options: [
                "Collect & Compute",
                "Comply",
                "Sustainability Communication", 
            ]
        },
        {
            field_title: "Travel & Expense",
            field_options: [
                "Cards Management",
                "Expense Management"
            ]
        },
        {
            field_title: "Capture (Real World Experiment)",
            field_options: [
                "Scientific References & Documentation",
                "Study, Experiment & Test Management", 
            ]
        },
        {
            field_title: "Create (Product Development)",
            field_options: [
                "Digital Asset Management (R&D)",
                "Product Management",
                "Substance Management", 
            ]
        },
        {
            field_title: "Exploit (Data & Model Management)",
            field_options: [
                "Audit Management",
                "Data Governance (R&D)",
                "Data Ingestion & Storage",
                "Digital Content Development", 
            ]
        },
        {
            field_title: "Portfolio Management",
            field_options: [
                "Above the Skin (Polaris)",
                "Below the Skin (Polaris)"
            ]
        },
        {
            field_title: "Simulate (Virtual World Experiment)",
            field_options: [
                "Equivalence & Threshold",
                "Optimisation",
                "Simulation & Visualisation", 
            ]
        },
        {
            field_title: "Make (In-House & 3P)",
            field_options: [
                "CM Management",
                "Industrial IoT",
                "Manufacturing Engineering",
                "Manufacturing Maintenance",
                "Materials & Inventory Management",
                "Production Operation", 
            ]
        },
        {
            field_title: "Quality Management",
            field_options: [
                "Inbound Supplier Quality",
                "Logistics Quality",
                "Manufacturing Quality",
                "Marketplace/Consumer Quality",
                "Product Safety", 
            ]
        },
        {
            field_title: "Safety",
            field_options: [
                "3P Safety",
                "Employee Safety",
                "Site Safety"
            ]
        },
        {
            field_title: "Security",
            field_options: [
                "3P Security",
                "Employee Security",
                "Site Security"
            ]
        },
        {
            field_title: "Compliance & Audit",
            field_options: [
                "Access Controls",
                "Controls Monitoring",
                "External Audit & Annual Reports",
                "Internal Audit", 
            ]
        },
        {
            field_title: "External Reporting & Consolidation",
            field_options: [
                "ESG Reporting",
                "Financial Reporting (inc Consolidation)",
                "Interco Operations",
                "Local Statutory Reporting",
                "Non-SC Capex & Fixed Assets Management", 
            ]
        },
        {
            field_title: "Finance Operations",
            field_options: [
                "BMI Operations",
                "CD Finance Services",
                "Finance Master Data Operations",
                "Non-SAP Finance Services",
                "Overheads Management",
                "SC Finance Services", 
            ]
        },
        {
            field_title: "Legal",
            field_options: [
                "BI & Compliance Management",
                "Brand Protection",
                "Contract Lifecycle Management",
                "M&A",
                "Matter Management & Operationss",
                "Patents & IP",
                "Privacy", 
            ]
        },
        {
            field_title: "Planning & Performance Management",
            field_options: [
                "Finance Info Model",
                "Financial Forecasting",
                "Management Reporting", 
            ]
        },
        {
            field_title: "Tax & Treasury",
            field_options: [
                "Bank Management & Treasury Payments",
                "FCCR",
                "Forex Management",
                "Tax Operations", 
            ]
        },
        {
            field_title: "Corporate Communication",
            field_options: [
                "External Comms",
                "Internal Comms"
            ]
        },
        {
            field_title: "Employee & Collaboration Tech Experience",
            field_options: [
                "AI Go Wide",
                "Assistive Technology",
                "Employee Collaboration",
                "End User Computing",
                "Service Desk/Deskside Support", 
            ]
        },
        {
            field_title: "Enterprise Platforms",
            field_options: [
                "Automation (Tech Foundation)",
                "ERP",
                "Integration",
                "IT for IT",
                "Low Code/No Code", 
            ]
        },
        {
            field_title: "Facility Services",
            field_options: [
                "Building Services",
                "Employee Services",
                "Event Management",
                "Site Security Services",
                "Workplace Technologies", 
            ]
        },
        {
            field_title: "Master Data Tech",
            field_options: [
                "Master Data Tech"
            ]
        },
        {
            field_title: "Risk & Compliance",
            field_options: [
                "AI Assurance",
                "Control & Compliance"
            ]
        },
        {
            field_title: "Technology Infrastructure",
            field_options: [
                "Cloud Services",
                "Secure Connectivity"
            ]
        },
        {
            field_title: "Travel Services",
            field_options: [
                "Travel & Fleet"
            ]
        }, 
    ],
    field_editable: "",
    field_column_size: "",
    value: "product"
};


/***/ }),

/***/ 33272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ botForm_CreateETForm; },
  "_": function() { return /* binding */ updateDropdownList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/botForm/formElements/InputDropdown.jsx
var InputDropdown = __webpack_require__(36651);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components/botForm/formElements/useETFormState.js




var useETFormState = function() {
    var ref = (0,react.useState)({
        employeeTwinName: "",
        employeeTwinDescription: "",
        status: "",
        leadPlatform: "",
        area: "",
        subArea: "",
        cluster: "",
        mco: "",
        country: "",
        geoItPartner: "",
        businessOwner: "",
        manualhour: null,
        fte: null,
        softSkill: "",
        transactions: "",
        reporting: "",
        cognitive: "",
        decisionautomations: ""
    }), formData = ref[0], setFormData = ref[1];
    var updateForm = function(name, value) {
        setFormData(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, name, value));
        });
    };
    var clearForm = function() {
        setFormData({
            employeeTwinName: "",
            employeeTwinDescription: "",
            status: "",
            leadPlatform: "",
            area: "",
            subArea: "",
            cluster: "",
            mco: "",
            country: "",
            geoItPartner: "",
            businessOwner: "",
            manualhour: null,
            fte: null,
            softSkill: "",
            transactions: "",
            reporting: "",
            cognitive: "",
            decisionautomations: ""
        });
    };
    return {
        formData: formData,
        updateForm: updateForm,
        clearForm: clearForm
    };
};
/* harmony default export */ var formElements_useETFormState = (useETFormState);

// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/lib/tw-merge.mjs + 10 modules
var tw_merge = __webpack_require__(57851);
;// CONCATENATED MODULE: ./components/botForm/formElements/additionalFields.js
var additionalFields = [
    {
        label: "Geo IT Partner",
        name: "geoItPartner",
        placeholder: "eg:email@unilever.com",
        inputType: "email",
        value: "geoItPartner"
    },
    {
        label: "Business Owner",
        name: "businessOwner",
        placeholder: "eg:email@unilever.com",
        inputType: "email",
        value: "businessOwner"
    },
    {
        label: "Business Request",
        name: "businessRequest",
        placeholder: "eg:email@unilever.com",
        inputType: "email",
        value: "businessRequest"
    },
    {
        label: "Manual Hour",
        name: "manualhour",
        placeholder: "Enter manual hour",
        inputType: "number",
        value: "manualhour"
    },
    {
        label: "FTE Saving",
        name: "fte",
        placeholder: "Enter FTE saving",
        inputType: "number",
        value: "fte"
    }, 
];
var skillFields = [
    {
        label: "Soft Skills",
        name: "softSkill",
        placeholder: "Search soft skills",
        value: "softSkill"
    },
    {
        label: "Transactions Skill",
        name: "transactions",
        placeholder: "Search transaction skills",
        value: "transactions"
    },
    {
        label: "Reporting Skills",
        name: "reporting",
        placeholder: "Search reporting skills",
        value: "reporting"
    },
    {
        label: "Cognitive Skills",
        name: "cognitive",
        placeholder: "Search cognitive skills",
        value: "cognitive"
    },
    {
        label: "Decisionautomations Skills",
        name: "decisionautomations",
        placeholder: "Search decisionautomations skills",
        value: "decisionautomations"
    }, 
];
var prefilledForm = {
    newRequest: "New Request",
    uploadPhoto: "TBD",
    globalSkill: "TBD",
    localSkill: "TBD",
    uploadDocument: "TBD",
    businessgroup: "TBD",
    businessunit: "TBD",
    businessoption: "TBD"
};
var notMandatoryFields = [
    "softSkill",
    "transactions",
    "reporting",
    "cognitive",
    "decisionautomations", 
];

;// CONCATENATED MODULE: ./components/botForm/formElements/InputText.jsx





var InputText = function(param) {
    var label = param.label, value = param.value, placeholder = param.placeholder, name = param.name, updateForm = param.updateForm, className = param.className, _inputType = param.inputType, inputType = _inputType === void 0 ? "text" : _inputType, searchedSkill = param.searchedSkill, updateSkills = param.updateSkills, formData = param.formData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,tw_merge/* twMerge */.m)("relative flex flex-col gap-2 font-unilever-shilling-normal text-[12px] ".concat(className)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "my-0 font-unilever-shilling-normal text-[13px]",
                children: [
                    label,
                    !notMandatoryFields.includes(name) && "*"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: "!border !border-[#C8D3DE] p-2 outline-none",
                type: inputType,
                name: name,
                id: "",
                placeholder: placeholder,
                value: value,
                onChange: function(e) {
                    return updateForm(e.target.name, e.target.value);
                }
            }),
            searchedSkill && searchedSkill.type === name && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        name: name,
                        onChange: function() {
                            return updateSkills(name, searchedSkill.id);
                        },
                        value: searchedSkill.id,
                        checked: formData[name].includes(searchedSkill.id)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "!my-0 text-[11px]",
                        children: [
                            searchedSkill.id,
                            " - ",
                            searchedSkill.name
                        ]
                    })
                ]
            }),
            (formData === null || formData === void 0 ? void 0 : formData[name]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-1",
                children: [
                    "Skill List:",
                    " ",
                    formData[name].length > 1 ? formData[name].split(",").map(function(item, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item
                        }, idx);
                    }) : formData[name]
                ]
            })
        ]
    });
};
/* harmony default export */ var formElements_InputText = (InputText);

;// CONCATENATED MODULE: ./components/botForm/formElements/InputTextarea.jsx



var InputTextarea = function(param) {
    var label = param.label, value = param.value, placeholder = param.placeholder, name = param.name, updateForm = param.updateForm, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,tw_merge/* twMerge */.m)("relative flex flex-col gap-2 font-unilever-shilling-normal text-[12px] col-span-3 ".concat(className)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "my-0 font-unilever-shilling-normal text-[13px]",
                children: [
                    label,
                    "*"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                className: "!border !border-[#C8D3DE] p-2 outline-none h-20",
                name: name,
                placeholder: placeholder,
                value: value,
                onChange: function(e) {
                    return updateForm(e.target.name, e.target.value);
                }
            })
        ]
    });
};
/* harmony default export */ var formElements_InputTextarea = (InputTextarea);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/shared/config.js
var shared_config = __webpack_require__(60344);
// EXTERNAL MODULE: ./components/botForm/formElements/CheckboxInputDropdown.jsx
var CheckboxInputDropdown = __webpack_require__(19256);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
;// CONCATENATED MODULE: ./components/botForm/CreateETForm.jsx
















var MAPPING = {
    family: "domain",
    product: "family",
    area: "leadPlatform",
    subArea: "area",
    mco: "cluster",
    country: "mco"
};
var FIELD_RESET_MAPPING = {
    leadPlatform: [
        "area",
        "subArea"
    ],
    area: [
        "subArea"
    ],
    cluster: [
        "mco",
        "country"
    ],
    mco: [
        "country"
    ]
};
var updateDropdownList = function(item, formData) {
    if (item.value === "domain" || item.value === "leadPlatform" || item.value === "cluster" || item.value === "engagementLead" || item.value === "status") {
        return item.field_options;
    } else if (item.value === "country") {
        var ref;
        //
        var getCountryArr = (ref = formData[MAPPING["country"]]) === null || ref === void 0 ? void 0 : ref.split(",");
        var getList = getCountryArr.map(function(country) {
            var getMCO = item.field_dropdown_option_component.find(function(listItem) {
                return listItem.field_title === country;
            });
            return (getMCO === null || getMCO === void 0 ? void 0 : getMCO.field_options) || [];
        });
        return getList.flat() || [];
    } else {
        var findList = item.field_dropdown_option_component.find(function(listItem) {
            return listItem.field_title === formData[MAPPING[item.value]];
        });
        return (findList === null || findList === void 0 ? void 0 : findList.field_options) || [];
    }
};
var CreateETForm = function(param) {
    var closeETForm = param.closeETForm, globalData = param.globalData, formDataBots = param.formDataBots, setNewlyCreatedET = param.setNewlyCreatedET, state = param.state;
    var CLUSTER = globalData.cluster_main_component;
    var LEAD_PLATFORM = globalData.lead_platform_main_component;
    var ENGAGEMENT_LEAD = formDataBots.find(function(item) {
        return item.field_label === "Engagement Lead";
    });
    var STATUS = {
        field_label: "Status",
        field_input: "Select status",
        value: "status",
        field_options: [
            "Live",
            "Build"
        ]
    };
    var ref = formElements_useETFormState(), formData = ref.formData, updateForm = ref.updateForm, clearForm = ref.clearForm;
    var ref1 = (0,react.useState)(null), searchedSkill = ref1[0], setSearchedSkill = ref1[1];
    var ref2 = (0,react.useState)(""), error = ref2[0], setError = ref2[1];
    var router = (0,next_router.useRouter)();
    var searchSkills = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(name, value) {
            var API, auth, config, ref, res, data, formatData, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (value.length < 2) return [
                            2
                        ];
                        API = name === "softSkill" ? "https://automation.unilever.com/api/softSkill/get?softSkillID=".concat(value) : "https://automation.unilever.com/api/botSearch/globalLocal?botID=".concat(value);
                        if (true) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                        }
                        config = {
                            headers: {
                                Authorization: auth.accessToken
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default().get(API, config)
                        ];
                    case 2:
                        res = _state.sent();
                        if (res.data.message === "Error while authentication") {
                            setError("Session Expired - Moving to Home");
                            setTimeout(function() {
                                closeETForm();
                                router.push("/");
                            }, [
                                700
                            ]);
                            return [
                                2
                            ];
                        }
                        data = (ref = res.data.data) === null || ref === void 0 ? void 0 : ref[0];
                        formatData = name === "softSkill" ? {
                            id: data.softSkillID,
                            name: data.skillName,
                            type: name
                        } : {
                            id: data.botExternalId,
                            name: data.processName,
                            type: name
                        };
                        setSearchedSkill(formatData);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function searchSkills(name, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateSkills = function(name, value) {
        if (formData[name].includes(value)) {
            return;
        }
        if (!formData[name]) {
            updateForm(name, value);
        } else {
            updateForm(name, "".concat(formData[name], ",").concat(value));
        }
    // setSearchedSkill(null);
    };
    var submitETForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, auth, config, ref, getLatestET, nextET, getLength, employeeTwinID, payload, res, newET, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("formData", formData);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            //check for empty fields
                            for(_iterator = Object.keys(formData).filter(function(key) {
                                return !notMandatoryFields.includes(key);
                            })[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                key = _step.value;
                                if (!formData[key]) {
                                    setError("".concat(key, " is a required field"));
                                    return [
                                        2
                                    ];
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (true) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                        }
                        config = {
                            headers: {
                                Authorization: auth.accessToken
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            axios_default().get("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/bot/get-latest-et"), config)
                        ];
                    case 2:
                        getLatestET = _state.sent();
                        if (getLatestET.data.message === "Error while authentication") {
                            setError("Session Expired - Relogin");
                            return [
                                2
                            ];
                        }
                        nextET = Number((ref = getLatestET.data.data.employeeTwinID) === null || ref === void 0 ? void 0 : ref.split("T")[1]) + 1;
                        getLength = "".concat(nextET).length;
                        employeeTwinID = getLength <= 2 ? "ET000".concat(nextET) : "ET00".concat(nextET);
                        payload = (0,_object_spread/* default */.Z)({
                            employeeTwinID: employeeTwinID
                        }, formData, prefilledForm);
                        return [
                            4,
                            axios_default().post("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/bot/create-et"), payload, config)
                        ];
                    case 3:
                        res = _state.sent();
                        newET = res.data.data.employeeTwinName;
                        if (newET) {
                            setNewlyCreatedET(newET);
                            react_toastify_esm/* toast.success */.Am.success("".concat(newET, " created"));
                        }
                        console.log("newET", newET);
                        clearForm();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.log("Error", error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function submitETForm() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(state)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (state[key]) {
                    updateForm(key, state[key]);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        setError("");
    }, [
        formData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed z-[9999] shadow left-[50%] translate-x-[-50%] top-28 w-[95%] h-[70vh] max-h-[70vh] overflow-y-auto bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-[90%] mx-auto h-full py-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center font-unilever-shilling-medium text-[#1F36C7] text-lg",
                    children: "Create ET Profile"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-3 gap-5 mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-3 grid grid-cols-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formElements_InputText, {
                                label: "Employee Twin Name",
                                placeholder: "Enter employee description",
                                name: "employeeTwinName",
                                updateForm: updateForm,
                                value: formData["employeeTwinName"]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formElements_InputTextarea, {
                            label: "Employee Twin Description",
                            placeholder: "Enter employee twin name",
                            name: "employeeTwinDescription",
                            updateForm: updateForm,
                            value: formData["employeeTwinDescription"]
                        }),
                        (0,_to_consumable_array/* default */.Z)(LEAD_PLATFORM).concat((0,_to_consumable_array/* default */.Z)(CLUSTER), [
                            ENGAGEMENT_LEAD,
                            STATUS
                        ]).map(function(item, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: item.value === "mco" || item.value === "country" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxInputDropdown/* default */.Z, {
                                    label: item.field_label,
                                    placeholder: item.field_input,
                                    list: updateDropdownList(item, formData),
                                    name: item.value,
                                    updateForm: updateForm,
                                    value: formData[item.value]
                                }, idx) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDropdown/* default */.Z, {
                                    label: item.field_label,
                                    placeholder: item.field_input,
                                    list: updateDropdownList(item, formData),
                                    name: item.value,
                                    updateForm: updateForm,
                                    value: formData[item.value]
                                }, idx)
                            });
                        }),
                        additionalFields.map(function(field, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(formElements_InputText, {
                                label: field.label,
                                placeholder: field.placeholder,
                                name: field.name,
                                inputType: field.inputType,
                                updateForm: updateForm,
                                value: formData[field.value]
                            }, idx);
                        }),
                        skillFields.map(function(field, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(formElements_InputText, {
                                label: field.label,
                                placeholder: field.placeholder,
                                name: field.name,
                                updateForm: searchSkills,
                                //value={formData[field.value]}
                                searchedSkill: searchedSkill,
                                updateSkills: updateSkills,
                                formData: formData
                            }, idx);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-center py-4",
                    children: [
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "bg-red-500 capitalize w-[520px] mx-auto text-white py-2 text-center text-xs font-unilever-shilling-normal",
                            children: error
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-center gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: closeETForm,
                                    className: "font-unilever-shilling-normal text-sm !border !border-[#1f36c7] py-2 text-center min-w-[250px] text-[#1f36c7]",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: submitETForm,
                                    className: "font-unilever-shilling-normal text-sm bg-[#1f36c7] py-2 text-center min-w-[250px] text-white",
                                    children: [
                                        "Create ET ",
                                        formData.employeeTwinName
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var botForm_CreateETForm = (CreateETForm);


/***/ }),

/***/ 19256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_rx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55788);
/* harmony import */ var _shared_hook_useHandleClickOutside__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20288);




var CheckboxInputDropdown = function(param) {
    var label = param.label, value = param.value, placeholder = param.placeholder, _list = param.list, list = _list === void 0 ? [] : _list, name = param.name, updateForm = param.updateForm, _inputBg = param.inputBg, inputBg = _inputBg === void 0 ? "transparent" : _inputBg;
    var ref = (0,_shared_hook_useHandleClickOutside__WEBPACK_IMPORTED_MODULE_2__/* .useHandleClickOutside */ .v)(), isOpen = ref.isOpen, setIsOpen = ref.setIsOpen, ref1 = ref.ref;
    var handleUpdateForm = function(name, itemValue) {
        if (value.includes(itemValue)) {
            if (value.includes(",")) {
                var filterValue = value.split(",").map(function(c) {
                    return c.trim();
                }).filter(function(c) {
                    return c !== itemValue;
                }).join(",");
                //
                updateForm(name, filterValue);
            } else {
                updateForm(name, "");
            }
            return;
        }
        if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
            var combineValue = "".concat(value, ",").concat(itemValue);
            updateForm(name, combineValue);
        } else {
            updateForm(name, itemValue);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: ref1,
        className: "relative flex flex-col gap-2 font-unilever-shilling-normal text-[12px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "my-0 font-unilever-shilling-normal text-[13px]",
                children: [
                    label,
                    "*"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    backgroundColor: inputBg
                },
                onClick: function() {
                    return setIsOpen(true);
                },
                className: "flex items-center justify-between !border !border-[#C8D3DE] p-2 cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "capitalize",
                        children: value.substring(0, 36) || placeholder
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_rx__WEBPACK_IMPORTED_MODULE_3__/* .RxCaretDown */ .jX5, {
                        className: "w-5 h-5 transition-all ".concat(isOpen ? "rotate-180" : "")
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute z-[999999] top-[70px] left-0 bg-[#f7f8fc] max-h-[200px] overflow-y-auto w-full",
                children: list.map(function(item, idx) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        onClick: function() {
                            handleUpdateForm(name, item);
                        },
                        className: "px-2 py-3 transition-all hover:bg-[#f0f2f9] cursor-pointer flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "checkbox",
                                name: name,
                                checked: value === null || value === void 0 ? void 0 : value.includes(item)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                className: "my-0 font-unilever-shilling-normal text-[12px]",
                                children: item
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxInputDropdown);


/***/ }),

/***/ 36651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_rx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55788);
/* harmony import */ var _shared_hook_useHandleClickOutside__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20288);




var InputDropdown = function(param) {
    var label = param.label, value = param.value, placeholder = param.placeholder, _list = param.list, list = _list === void 0 ? [] : _list, name = param.name, updateForm = param.updateForm, _inputBg = param.inputBg, inputBg = _inputBg === void 0 ? "transparent" : _inputBg, _isShowing = param.isShowing, isShowing = _isShowing === void 0 ? true : _isShowing;
    var ref = (0,_shared_hook_useHandleClickOutside__WEBPACK_IMPORTED_MODULE_2__/* .useHandleClickOutside */ .v)(), isOpen = ref.isOpen, setIsOpen = ref.setIsOpen, ref1 = ref.ref;
    if (isShowing) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            ref: ref1,
            className: "relative flex flex-col gap-2 font-unilever-shilling-normal text-[12px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: "my-0 font-unilever-shilling-normal text-[13px]",
                    children: [
                        label,
                        "*"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        backgroundColor: inputBg
                    },
                    onClick: function() {
                        return setIsOpen(true);
                    },
                    className: "flex items-center justify-between !border !border-[#C8D3DE] p-2 cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "capitalize",
                            children: value || placeholder
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_rx__WEBPACK_IMPORTED_MODULE_3__/* .RxCaretDown */ .jX5, {
                            className: "w-5 h-5 transition-all ".concat(isOpen ? "rotate-180" : "")
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute z-[999999] top-[70px] shadow left-0 bg-[#f7f8fc] max-h-[200px] overflow-y-auto w-full",
                    children: list.map(function(item, idx) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onClick: function() {
                                updateForm(name, item);
                                setIsOpen(false);
                            },
                            className: "px-2 py-3 transition-all hover:bg-[#f0f2f9] cursor-pointer",
                            children: item
                        }, idx);
                    })
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (InputDropdown);


/***/ }),

/***/ 60344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ config; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(83454);
{}// config.js
var token;
var tokenWithoutBearer;
function initializeToken() {
    if ( true && !token) {
        var auth = JSON.parse(localStorage.getItem("auth"));
        if (auth && (auth === null || auth === void 0 ? void 0 : auth.data)) {
            tokenWithoutBearer = "".concat(auth.data.accessToken);
            token = tokenWithoutBearer.replace("Bearer ", "");
        }
    }
}
// Call initializeToken to populate the token
initializeToken();
var config = {
    baseUrl: "https://automation.unilever.com/api" || 0,
    get bearerToken () {
        // Call initializeToken to ensure token is up-to-date
        initializeToken();
        return process.env.NEXT_PUBLIC_BEARER_TOKEN || token;
    }
};


/***/ }),

/***/ 20288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useHandleClickOutside; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useHandleClickOutside = function() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleOutsideClick = function(event) {
            if (ref1.current && !ref1.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("click", handleOutsideClick);
        return function() {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, [
        ref1
    ]);
    return {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        ref: ref1
    };
};


/***/ })

}]);